import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { PAYMENTPAGE, Checkout } from "npmlinks-constants";
import { Utils } from "arv-reactcomponents";
import { readCookie, checkIfAllareStorePick } from "../../../utils";
import Otp from "./Otp";
import Captcha from "./Captcha";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@withRouter
@inject("CheckoutStore", "CodStore", "PaymentStore")
@observer
class Cod extends Component {
  constructor(props) {
    super(props);
    this.allStorePicks = false;
  }

  componentWillMount() {
    Analytics.trackEvent({
      action: Event.action.PAYMENT_COD_SELECTED,
      category: Event.category.CHECKOUT,
    });
    this.allStorePicks = checkIfAllareStorePick(this.currentCart);
    if (this.allStorePicks && !readCookie(PAYMENTPAGE.COD_COOKIE.NAME)) {
      this.props.CodStore.setCodVerified(true);
    } else {
      this.props.CodStore.setCodVerified();
    }
  }
  get isPaymentFailurePage() {
    return (
      this.props.location.pathname ===
      Checkout.CHECKOUT_ROUTES.SUPPORTED.paymentfailure
    );
  }
  get currentCart() {
    const { cartItems } = this.props.CheckoutStore;
    const localStorageData = Utils.localStorage.getItem("paymentRequest");
    const cartItemsFromStorage =
      (this.isPaymentFailurePage &&
        localStorageData &&
        localStorageData.productsShippingDetails) ||
      null;
    return cartItemsFromStorage || cartItems;
  }

  render() {
    if (this.props.CodStore.isCodVerified) {
      return <span />;
    } else if (
      process.env.REACT_APP_OTP_ENABLED === "true" &&
      !this.allStorePicks
    ) {
      return <Otp.component isPaymentFailurePage={this.isPaymentFailurePage} />;
    }
    return (
      <Captcha.component isPaymentFailurePage={this.isPaymentFailurePage} />
    );

    // const componentToRender = !this.props.CodStore.isCodVerified ? (
    //   process.env.REACT_APP_OTP_ENABLED === "true" && !this.allStorePicks ? (
    //     <Otp.component />
    //   ) : (
    //     <Captcha.component />
    //   )
    // ) : (
    //   <span />
    // );
    // return componentToRender;
  }
}

Cod.wrappedComponent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    cartItems: PropTypes.shape({}).isRequired,
  }).isRequired,
  CodStore: PropTypes.shape({
    setCodVerified: PropTypes.func.isRequired,
    isCodVerified: PropTypes.bool.isRequired,
  }).isRequired,
};

export { default as Captcha } from "./Captcha";
export { default as Otp } from "./Otp";

const getFinalComponent = component =>
  inject("CheckoutStore", "CodStore", "PaymentStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Cod,
  component: Cod,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/Cod/index.js